import {FigureMainClass} from "./figureMainClass";
import {MapPosition} from "../../models/MapPosition";
import {from, Observable, Subscriber} from "rxjs";
import {isRemoveSidebar} from "../../../configs/view_only";
import {ObjectConfig} from "../../models/ObjectConfig";
import {debounceTime} from "rxjs/operators";

export class ThreeDModel extends FigureMainClass{
  // public originalWidth : number = 5;
  // public originalHeight : number = 5;
  private _position : MapPosition;
  private _rotation : number;
  private _fixedWidth: number;
  private _fixedHeight: number;
  private _fixedScale: number;
  private _dragEndFires: number;
  private _mapIcon: string;
  private zoomHeight: number;
  private threeDMode: boolean;
  private isVisible: boolean = true;
  private isHighlightedForConcreteDrawing = false;
  private updateLinkedObjectsAnchorPosition$ = new Observable((observer)=>{
    this.updateLinkedObjectsAnchorPosition();
    observer.next()
  });

  get position() { return this._position; }
  set position(val) {
    if (val.lat === null || val.lng === null) {
      console.error("Illegal position for object", this.object, val);
      alert("Illegal position. Saving denied.\nPlease, reload the page.");
      return;
    }
    this._position = val;
    // note: [SHR]: difference
    this.updateLinkedObjectsAnchorPosition$.pipe(debounceTime(300)).subscribe(()=>{
      this.setObjectConfigValue('position', this._position);
    })
  }

  moveByOffsetFromOriginalPosition(offset){
    let _pos = Object.assign({}, this.position);
    let pos = new MapPosition({lat: _pos.latitude+offset.latitude, lng: _pos.longitude+offset.longitude});
    this.lastDragPosition = pos;
    if (this.viewEntityId){
      this.view.moveModel(this.viewEntityId, pos);
    }
    if (this.fallbackEntityId){
      this.view.moveModel(this.fallbackEntityId, pos);
    }
  }


  get mapIcon() { return this._mapIcon; }
  get initialConfig() { return this.getInitialConfig(); }

  get preparedMapIcon(){

    let preparedMapIcon = this.mapIcon;
    if (this._mapIcon.indexOf('.png')  == this._mapIcon.length - 4){
      preparedMapIcon = this._mapIcon.slice(0, this._mapIcon.indexOf('.png'))+'-v5.gltf';
    } else if (this._mapIcon.indexOf('.jpg')  == this._mapIcon.length - 4){
      preparedMapIcon = this._mapIcon.slice(0, this._mapIcon.indexOf('.jpg'))+'-v5.gltf';
    } else if (this._mapIcon.indexOf('.jpeg')  == this._mapIcon.length - 5){
      preparedMapIcon = this._mapIcon.slice(0, this._mapIcon.indexOf('.jpeg'))+'-v5.gltf';
    } else if (this._mapIcon.indexOf('?') > 0) {
      preparedMapIcon = this._mapIcon + '&format=gltf';
    }
    return preparedMapIcon;
  }

  get rotation() { return this._rotation; }
  set rotation(val) {
    this._rotation = val;
    this.setObjectConfigValue('rotation', this._rotation);
  }

  get finalWidth(){ return this._fixedWidth; }
  get finalHeight(){ return this._fixedHeight; }
  get finalScale(){ return this._fixedScale; }
  get finalSize(){return {width: this._fixedWidth, height: this._fixedHeight}}

  protected __init(config) {
      // this.originalWidth = 5;
      // this.originalHeight = 5;
    if (!isRemoveSidebar) {
      this.view.isThreeDMode.subscribe((val) => {
        this.threeDMode = val;
        this.setVisibility(this.isVisible);
      });
    }
      this._position = config.getPosition();
      this._rotation = config.getRotation();
      this._fixedScale = config.getFixedScale();
      this._fixedWidth = config.getFixedWidth();
      this._fixedHeight = config.getFixedHeight();
      this._mapIcon = config.getMapIcon();
  }

  public setGrayScale(value){
    if (this.isHighlightedForConcreteDrawing) { return; }
      // console.log('setGrayScale', value, this.viewEntityId);
      if (this.viewEntityId){
        this.view.setEntityGrayscale(this.viewEntityId, value);
      }

      if (this.fallbackEntityId){
        this.view.setEntityGrayscale(this.fallbackEntityId, value);
      }
  }

  public setVisibility(isVisible) {
    this.isVisible = isVisible;
    let val = this.threeDMode;
    // if (this.viewEntityId) {
    //   this.view.setVisibility(this.viewEntityId, isVisible);
    // }
    // console.log('setVisibility', val, isVisible, this.viewEntityId, this.fallbackEntityId)
    if (val && this.viewEntityId){
      this.view.setEntityVisible(this.viewEntityId, isVisible);
      if (this.fallbackEntityId) {
        this.view.setEntityVisible(this.fallbackEntityId, false);
      }
    } else if (!val){
      if (this.viewEntityId){
        this.view.setEntityVisible(this.viewEntityId, false);
      }
      if (this.fallbackEntityId) {
        this.view.setEntityVisible(this.fallbackEntityId, isVisible);
        this.view.setModelBoxTransparentAndImage(this.fallbackEntityId, true);
      }
      // this.view.setModelBoxDimensionHeight(this.fallbackEntityId,100000000);
    } else if (val && !this.viewEntityId && this.fallbackEntityId){
      this.view.setEntityVisible(this.fallbackEntityId, isVisible);
      this.view.setModelBoxTransparentAndImage(this.fallbackEntityId, false);
      // this.view.setModelBoxDimensionHeight(this.fallbackEntityId, 2.5);
    }
  }

  protected __onInternalUpdate(config){
    this.updateFigureSizeFromConfig(config);
    this.updateMapIcon(config);
    if (!this._position.equals(config.getPosition())) {
      this._position = config.getPosition();
      this.updateModelPosition();
      this.updateLinkedObjectsAnchorPosition();
    }
    this.view.viewer.scene.requestRender();
  }

  protected __onServerUpdate(config) {
    if (!this._position.equals(config.getPosition())) {
      this._position = config.getPosition();
    }
    this.updateModelPosition();
    if (this._rotation != config.getRotation()) {
      this._rotation = config.getRotation();
      this.view.rotateModel(this.viewEntityId, this.rotation);
      this.view.rotateModel(this.fallbackEntityId, this.rotation)
    }

    this.updateFigureSizeFromConfig(config);
    this.updateMapIcon(config);
    this.view.viewer.scene.requestRender();
  }

  private updateModelPosition(){
    if (this.viewEntityId){
      this.view.moveModel(this.viewEntityId, this.position)
    }
    if (this.fallbackEntityId){
      this.view.moveModel(this.fallbackEntityId, this.position);
    }
  }

  private updateMapIcon(config: ObjectConfig) {
    if (config.getMapIcon() != this._mapIcon) {
      this._mapIcon = config.getMapIcon();
      if (this.viewEntityId){
        this.view.changeModelMapIcon(this.viewEntityId, this.preparedMapIcon);
      }
      if (this.fallbackEntityId){
        this.view.changeModelMapIcon(this.fallbackEntityId, this.preparedMapIcon);
      }
    }
  }

  public forceResize(config: ObjectConfig, additionalOptions?){
    if (this.fallbackEntityId){
      this.view.changeModelFixedSize(this.fallbackEntityId, this.finalScale, this.finalWidth, this.finalHeight, this.getInitialConfig(), additionalOptions);
    }

    if (this.viewEntityId){
      this.view.changeModelFixedSize(this.viewEntityId, this.finalScale, this.finalWidth, this.finalHeight, this.getInitialConfig(), additionalOptions);
    }
  }

  protected updateFigureSizeFromConfig(config:ObjectConfig){
    if (this._fixedWidth != config.getFixedWidth() || this._fixedHeight != config.getFixedHeight() || this._fixedScale != config.getFixedScale()){
      this._fixedScale = config.getFixedScale();
      this._fixedWidth = config.getFixedWidth();
      this._fixedHeight = config.getFixedHeight();
      if (this.fallbackEntityId){
        this.view.changeModelFixedSize(this.fallbackEntityId, this.finalScale, this.finalWidth, this.finalHeight, this.getInitialConfig());
      }

      if (this.viewEntityId){
        this.view.changeModelFixedSize(this.viewEntityId, this.finalScale, this.finalWidth, this.finalHeight, this.getInitialConfig());
      }
      else{
        //todo: check zoom config when viewerEntityId will be in Promise then
        let self = this;
        setTimeout(()=>{
          self.updateFigureSizeFromConfig(config);
        }, 500)
      }
    }
  }

  private initThreeDListeners(){
    this.view.isThreeDMode.subscribe((val)=>{
      if (val && this.viewEntityId){
        this.view.setEntityVisible(this.viewEntityId, true);
        if (this.fallbackEntityId) {
          this.view.setEntityVisible(this.fallbackEntityId, false);
        }
      }

      if (!val){
        if (this.viewEntityId){
          this.view.setEntityVisible(this.viewEntityId, false);
        }

        if (this.fallbackEntityId){
          this.view.setEntityVisible(this.fallbackEntityId, true);
          this.view.setModelBoxTransparentAndImage(this.fallbackEntityId, true);
        }
        // this.view.setModelBoxDimensionHeight(this.fallbackEntityId,100000000);
      }

      if (val && !this.viewEntityId && this.fallbackEntityId){
        this.view.setEntityVisible(this.fallbackEntityId, true);
        this.view.setModelBoxTransparentAndImage(this.fallbackEntityId, false);
        // this.view.setModelBoxDimensionHeight(this.fallbackEntityId, 2.5);
      }
    })
  }

  public draw() {
    return from(new Observable((observer)=>{
        if (this.view.sceneRotatedDegrees!== 0){
          this.rotation += this.view.sceneRotatedDegrees;
        }
        this.view.drawThreeDModel(
          this.tool,
          this,
          (entityIdObj) => {
                this.setEntityId(entityIdObj, observer);
            }
        );
      }))
    // return new Promise((resolve, reject)=>{
    //
    //   this.view.drawThreeDModel(
    //     this.tool,
    //     this,
    //     (entityIdObj) => { this.setEntityId(entityIdObj, resolve); }
    //   );
    // })
  }

  public removeObject(){
    if (this.viewEntityId){
      this.view.removeObject(this.viewEntityId);
    }
    this.view.removeObject(this.fallbackEntityId);
  }

  private setEntityId(obj:{type, id}, observer:Subscriber<any>){
    if (obj.type == 'model'){
      this.setViewEntityId(obj.id);
    }
    else{
      this.fallbackEntityId = obj.id;
    }
    observer.next(obj.id);
  }

  public getRotation(){
    return this.rotation;
  }

  public rotateTo(degrees){
    return new Promise((resolve)=>{
      this.rotation=degrees;
      if(this.viewEntityId){
        this.view.rotateModel(this.viewEntityId, this.rotation, resolve)
      }
      this.view.rotateModel(this.fallbackEntityId, this.rotation, resolve)
    })
  }

  public rotate(degrees){
    return new Promise((resolve)=>{
      this.rotation+=degrees;
      if(this.viewEntityId){
         this.view.rotateModel(this.viewEntityId, this.rotation, resolve)
      }
       this.view.rotateModel(this.fallbackEntityId, this.rotation, resolve)
    })
  }

  public moveBy(offset) {
    let pos = Object.assign({}, this.position);

    this.position = new MapPosition({lat: pos.latitude+offset.latitude, lng: pos.longitude+offset.longitude});
    if (this.viewEntityId){
      this.view.moveModel(this.viewEntityId, this.position);
    }
    if (this.fallbackEntityId){
      this.view.moveModel(this.fallbackEntityId, this.position);
    }
  }

  updateObjectPositionByMultiSelect(){
    if (this.lastDragPosition){
      this.position = this.lastDragPosition;
      this.lastDragPosition = null;
    }
  }

  public moveWithDirection(event){
    let newPos = this.view.getPositionAfterDirectionOffset(this.position, event);
    this.position = newPos;
    if (this.viewEntityId){
      this.view.moveModel(this.viewEntityId, newPos);
    }
    if (this.fallbackEntityId){
      this.view.moveModel(this.fallbackEntityId, newPos);
    }
  }


  getLinkedObjectsAnchorPosition(){
    return this.position;
  }

  public onDragEnd(object: {position, id}){
    this._dragEnd.next({oldPosition: Object.assign({}, this.position), object});
    this.position = object.position;
  }

  public onRotateStart(){
    if (this.view.viewer.scene.mode == 3 && this.viewEntityId){
      this.view.enableObjectRotate(this.viewEntityId, this.position, this.rotation, (degrees)=>{this.rotation = degrees;})
    }
    else if (this.fallbackEntityId){
      this.view.enableObjectRotate(this.fallbackEntityId, this.position, this.rotation, (degrees)=>{this.rotation = degrees;})
    }

  }

  public setTransparency(value){
    if (this.viewEntityId) {
      this.view.setObjectTransparency(this.viewEntityId, false);
    }
    if (this.fallbackEntityId) {
      this.view.setObjectTransparency(this.fallbackEntityId, true);
    }
  }

  public centerOnObject(offsetHeight){
     (this.viewEntityId) ? this.view.centerOnEntity(this.viewEntityId, this.position, offsetHeight) : this.view.centerOnEntity(this.fallbackEntityId, this.position, offsetHeight)
  }

  // note: [SHR]: difference
  startDrag(isMultiSelect?){
    if (this.view.viewer.scene.mode == 3 && this.viewEntityId){
      super.startDrag(isMultiSelect);
    }
    else if (this.fallbackEntityId){
      this.view.startDragObject(this.fallbackEntityId, isMultiSelect);
    }
  }

  public highlightForConcreteDrawing() {
    // this.isHighlightedForConcreteDrawing = true;
      if (this.viewEntityId) {
        // this.view.highlightForConcreteDrawing3DModel(this.viewEntityId);
        this.view.setEntityVisible(this.viewEntityId, false);
      }
      if (this.fallbackEntityId) {
        this.view.setEntityVisible(this.fallbackEntityId, true);
        this.view.highlightForConcreteDrawingBox(this.fallbackEntityId);
      }
  }

  public removeHighlightForConcreteDrawing() {
    this.isHighlightedForConcreteDrawing = false;
      if (this.viewEntityId && this.threeDMode) {
        this.view.setEntityVisible(this.viewEntityId, true);
        if (this.fallbackEntityId) {
          this.view.setEntityVisible(this.fallbackEntityId, false);
        }
      }
      if (this.fallbackEntityId) {
        this.view.removeHighlightForConcreteDrawingBox(this.fallbackEntityId);
      }
  }

  // public stopDrag(){
  //   this.view.stopDragEntity();
  // }
}
